/**
 * Canonical tab slugs for field detail URL routing (G.23).
 * Single source of truth for /fields/{id}/{slug} validation.
 */

export const FIELD_TAB_SLUGS = [
  'overview',
  'yield',
  'rotation',
  'economics',
  'soil',
  'activities',
  'weather',
  'pois',
  'notes',
  'audit-log',
  'compliance',
  'insurance',
  'sharing',
];

export const DEFAULT_FIELD_TAB = 'overview';

/**
 * Validate and normalize a tab slug from a URL.
 * Returns DEFAULT_FIELD_TAB if the slug is invalid or missing.
 */
export function resolveTabSlug(slug) {
  if (!slug) return DEFAULT_FIELD_TAB;
  const normalized = String(slug).toLowerCase().trim();
  if (FIELD_TAB_SLUGS.includes(normalized)) return normalized;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(`[fieldTabSlugs] Unknown tab slug "${slug}". Falling back to "${DEFAULT_FIELD_TAB}".`);
  }
  return DEFAULT_FIELD_TAB;
}
